import styled from "styled-components";
import { space } from "styled-system";

export const StyledIcon = styled.div`
  ${space}
`;
